import React from 'react';

import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: 'https://522d3853c01a011f89ce65acb2725f03@o338394.ingest.us.sentry.io/4509599944474624',
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	release: __SENTRY_RELEASE__,
	integrations: [
		Sentry.reactRouterV7BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes
		})
	],
	tracesSampleRate: 0.001,
	denyUrls: [
		// Facebook
		// https://connect.facebook.net/en_US/pcm.js
		/connect\.facebook\.net\//i,
		// Safari extensions
		/hidden\//i,
		// Chrome extensions
		/extensions\//i,
		/^chrome:\/\//i,
		/^chrome-extension:\/\//i
	],
	ignoreErrors: [
		// ---
		// Random plugins/extensions
		'top.GLOBALS',
		// ---
		// Ignore errors around Chrome iOS JS shims
		/__gCrWeb/,
		// ---
		// Ignore Microsoft SafeLinks shenanigans - cefsharp errors
		/Non-Error promise rejection captured with value: Object Not Found Matching Id:\d*, MethodName:\w*, ParamCount:\d*/,
		// ---
		// Ignore Microsoft SafeLinks shenanigans
		/Unable to preload CSS for/,
		//
		// The following errors list is taken from the Sentry Tips & Tricks page
		// which leads to the following gist in Github: https://gist.github.com/impressiver/5092952
		//
		// See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
		'originalCreateNotification',
		'canvas.contentDocument',
		'MyApp_RemoveAllHighlights',
		'http://tt.epicplay.com',
		"Can't find variable: ZiteReader",
		'jigsaw is not defined',
		'ComboSearch is not defined',
		'http://loading.retry.widdit.com/',
		'atomicFindClose',
		// ---
		// Facebook borked
		'fb_xd_fragment',
		// ---
		// ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
		// See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
		'bmi_SafeAddOnload',
		'EBCallBackMessageReceived',
		// ---
		// See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
		'conduitPage',
		// ---
		// Generic error code from errors outside the security sandbox
		// You can delete this if using raven.js > 1.0, which ignores these automatically.
		'Script error.',
		// ---
		// Offline plugin adds the `__uncache=DATE_IN_ISO_URL_ENCODED_STRING` argument to the path of
		// each cached file. When a new version of the file is found, Offline plugin invalidates the previous
		// version and removes it from the browser cache. This is where Firefox and Safari throw errors because
		// apparently they try to load the files. These kinds of errors have no impact on the user experience
		// and the user interface because the browsers load the latest version of the files provided by the
		// Offline plugin.
		// That's why we don't need to know about them and we filter them out.
		/.*(\?__uncache=\d.).*/,
		// ---
		// Due to the way we redeploy the app and the caching implemented using service workers,
		// users may have an outdated version of the chunks which will cause Sentry to throw this error,
		// The service worker will download the correct chunk but Sentry will still report this error.
		// We don't want such noise.
		'ChunkLoadError',
		'Loading CSS chunk',
		// ---
		// Firefox throws this error upon subsequent service worker registration
		// https://stackoverflow.com/questions/11768221/firefox-websocket-security-issue/12042843#12042843
		'The operation is insecure.',
		// ---
		// This happens when the user navigates away from the page or closes a tab while a network request is still pending
		// In this case the browser aborts the fetch request which throws this error
		'Fetch is aborted',
		// ---
		// Chromium based browsers and Firefox report aborted/cancelled network requests as failed
		'Failed to fetch',
		'TypeError: Failed to fetch',
		'NetworkError when attempting to fetch resource.',
		'TypeError: NetworkError when attempting to fetch resource.'
	]
});
